<template>
  <div class="iv-project-declare iv-p-t-24 iv-p-b-40">
    <div class="iv-main-width">
      <Tab v-model="tabName" :navList="navList" @on-click="tabClick"></Tab>
      <List
        v-if="list.length > 0"
        type="project" 
        :map="map" 
        :showPage="true" 
        :total="total" 
        :list="list"
        :current="currentPage"
        :pageSize="pageSize"
        class="iv-m-t-24" 
        @on-detail="detailPage" 
        @on-change="changePage"
        @on-page-size-change="changePageSize">
      </List>
      <NoData v-if="list.length <= 0"></NoData>
    </div>
  </div>
</template>

<script>
import Tab from '@/components/tab'
import NoData from '@/components/no-data'
import List from '@/components/declare-list'
import { listApplication } from './interface'

export default {
  data () {
    return {
      list: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      infoState: 'SBZT02',
      paramsKey: 'infoState',
      tabName: 'SBZT02'
    }
  },
  created () {
    this.currentPage = Number(this.$route.query.currentPage) || 1
    this.initTabs()
    this.map = {
      title: 'applicationName',
      orgName: 'publishOrgName',
      publishDate: 'publishTime',
      endDate: 'applicationDeadline'
    }
    this.tabName = this.$route.query.tabName || 'SBZT02'
    this.tabClick(this.tabName, 'create')
  },
  methods: {
    tabClick (name, type) {
      if (name == 'SBZT02' || name == 'SBZT04') {
        this.paramsKey = 'infoState'
        this.infoState = name
      } else if (name == 'signup') {
        this.paramsKey = 'isReport'
        this.infoState = true
      } else {
        this.paramsKey = 'isAward'
        this.infoState = true
      }
      this.tabName = name
      if (!type) {
        this.currentPage = 1
      }
      this.getAppraisingList()
    },
    //获取项目列表
    getAppraisingList () {
      listApplication({
        bizTypeCode: 'YWLX02',
        [this.paramsKey]: this.infoState,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }).then((data) => {
        this.list = data.data
        this.total = data.count
      })
    },
    changePage (page) {
      this.currentPage = page
      this.getAppraisingList()
    },
    changePageSize (page) {
      this.pageSize = page
      this.getAppraisingList()
    },
    //跳转详情
    detailPage (item) {
      let type = 'edit'
      // item.isReportState === false || 
      if (this.infoState == 'SBZT04' || this.paramsKey == 'isAward') {
        type = 'see'
      }
      this.$router.push({
        name: 'projectDetail',
        query: {
          applicationInfoId: this.$encode(item.applicationInfoId),
          type: this.$encode(type),
          bizLineCode: this.$encode(item.bizLineCode),
          isSignUp: this.tabName === 'signup',
          currentPage: this.currentPage,
          tabName: this.tabName
        }
      })
    },
    initTabs () {
      this.navList = [{
        label: '进行中',
        name: 'SBZT02'
      }, {
        label: '已结束',
        name: 'SBZT04'
      }, {
        label: '已报名',
        name: 'signup'
      }, {
        label: '申请成功',
        name: 'getPrize'
      }]
    }
  },
  components: {
    Tab,
    List,
    NoData
  }
}
</script>

<style lang="scss" scoped>
.iv-project-declare {
  min-height: 100%;
  background-color: #fff;
}
</style>
